import { Input, Label } from "@fluentui/react-components";
import { AddRegular, ArrowCircleLeftRegular } from "@fluentui/react-icons";
import * as React from "react";
import Select from "react-select";
import { customStyles } from "../UtilityFunctions/ReactSelectStyles";
import { fetchRequestListData, getFileInfo } from "../UtilityFunctions/CommonFunction";
import { Icon, IconButton, Link } from "@fluentui/react";
import ContextService from "../../services/ContextService";
import { Web } from "sp-pnp-js";
import { useGetSet } from "react-use";
import axios from "axios";
import SettingService from "../../services/SettingService";
import { Delete } from "../UtilityFunctions/Constants/Constants";
import DragAndDrop from "../DragnDrop/DragAndDrop";
import { PrimaryButton } from "@fluentui/react";
import { v4 as uuid } from "uuid";
import { SweetAlerts } from "../UtilityFunctions/SweetAlerts";
import { Spinner } from "office-ui-fabric-react";
let allRequestItems = [];
let setatt1 = [];
let setatt = [];
let remarksetatt = [];
let remarksetatt1 = [];
let documentTypesTemp = [];
let documentTypesKeyPairs = {};
let documentTypeID;
let addattachmentNames = [];
let taskAttachmentRoot=''
function GetFilesCLM(props) {
  // console.log(props);
  const uniqueGUID = uuid();
  const hideSampleData = JSON.parse(props?.SettingsListData?.RequestContractSampleData || '{}')?.RequestSampleData === 'No';
  const [fromFields, setFromFields] = React.useState({});
  const [allRequestOpt, setAllRequestOpt] = React.useState([]);
  const [selectedRequest, setSelectedRequest] = React.useState(undefined);
  const [attachmentFileDataTemp, setAttachmentFileDataTemp] = React.useState({});
  const [attachmentFileData, setAttachmentFileData] = React.useState({});
  const [data, setData] = useGetSet<any>({});
  const [documentTypesData, setDocumentTypesData] = React.useState({});
  const [attachremarkFile1, setattachremarkFile1] = React.useState([]);
  const [RetrieveFiles,setRetrieveFiles]=React.useState([])
  const [RetrieveFiles2,setRetrieveFiles2]=React.useState([])
  const [attachremarkFile2, setattachremarkFile2] = React.useState([]);
  const [attachfile, setAttachfile] = React.useState([]);
  const [addedFiles, setaddedFiles] = React.useState([]);
  const [attachFile2, setattachFile2] = React.useState([]);
  const [attachmentFile, setAttachmentFile] = React.useState<any>([]);
  const [FileImported, setFileImported] = React.useState(false);
  const [deleteAttachmentFiles, setDeleteAttachmentFiles] = React.useState({});
  const [documentTypeFiles, setDocumentTypeFiles] = React.useState<any>([]);
  const [deleteRemarkattach, setDeleteRemarkAttach] = React.useState([]);
  const [deleteDocumentsTypes, setDeleteDocumentTypes] = React.useState({});
  const [documentTypeTemp, setDocumentTypeTemp] = React.useState({});
  const [spinnerLoading, setspinnerLoading] = React.useState(false);
  const { SweetAlert: SweetalertsApproved,SweetPrompt:SweetPromptAlert } = SweetAlerts("#SweetalertGetFilesRequest");
  React.useEffect(() => {
    getAllRequestData();
  }, []);
  const getAllRequestData = async () => {
    setspinnerLoading(true)
    try {
      const requestItems = await fetchRequestListData(hideSampleData);
      // console.log(requestItems);
      const requestOptions = [];
      allRequestItems = [...requestItems];
      requestItems?.map((request) => {
        requestOptions.push({
          key: request?.Guid_ID,
          text: request?.Title,
          value: request?.Guid_ID,
          label: request?.Title,
        });
      });
      setAllRequestOpt(requestOptions);
      setspinnerLoading(false)
    } catch (error) {
      console.log(error);
      setspinnerLoading(false)
    }
  };

  const onChangeRequest = (item): void => {
 
    if (item) {
      setRetrieveFiles([])
      setRetrieveFiles2([]);
      setSelectedRequest(item.key as string);
      getRequestAttachmentData(item.key);
    }
  };

  const onChangeRetrieveFile=(ev)=>{
if(ev.target.files.length > 0){
 const  reterievesetatt1 = [];
 const reterievesetatt = [];
  let varlnth = 0;
  for (var i = 0; i < ev.target.files.length; i++) {
    let id = varlnth++;
    reterievesetatt.push(ev.target.files[i]);
    reterievesetatt1.push([
      <div
        className={"Attatchemntdiv"}
        title={ev.target.files[i].name}
        style={{ marginTop: "5px", width: "auto", maxWidth: "none" }}
      >
        <span className={"Attatcmenticons"}>
          <Icon
            styles={{
              root: {
                // marginTop: "3px",
                marginRight: "5px",
                marginLeft: "5px",
              },
            }}
            iconName="TextDocument"
          ></Icon>
        </span>
        <span className={"Attatchmentext1"}>
          {ev.target.files[i].name}
        </span>
        <Link
          // onClick={() => {
          //   deleteReterieveattach(id);
          // }}
          style={{ marginLeft: "auto",paddingRight:'5px' }}
        >

          {/* <IconButton
            styles={{
              icon: {
                color:
                  SettingService.GetTheme() == "light"
                    ? "var(--lightdarkColor) !important"
                    : "var(--lightdarkBGGray) !important",
              },
            }}
            iconProps={Delete}
          /> */}
          <AddRegular/>

        </Link>
      </div>,
    ]);

  }

  setRetrieveFiles((c) => ([...c,...reterievesetatt1])); 
  setRetrieveFiles2((c) => ([...c,...reterievesetatt]));
  setaddedFiles(reterievesetatt)
}
  }




  const getRequestAttachmentData = async (requestGUID) => {
    setRetrieveFiles([])
    setRetrieveFiles2([]);
    const currentRequestData = allRequestItems?.filter((request) => request?.Guid_ID === requestGUID) || [];
    setData((c) => ({
      ...c,
      currentItem: currentRequestData?.length ? currentRequestData[0] : {},
    }));
    await getDocumentAttachments(requestGUID);
    if (currentRequestData?.length > 0 && currentRequestData[0]?.Draft_Type != "Blank") {
      const fileName = currentRequestData[0]?.File_Name;
      const DraftType = currentRequestData[0]?.Draft_Type;
      const actualFileName = currentRequestData[0]?.ActualFileName;
      setData((c) => ({
        ...c,
        currentItem: currentRequestData[0],
      }));
      await getAllFiles(fileName, DraftType, actualFileName);
    }
    await getFilesByTask(requestGUID);
  };

  async function getAllFiles(FileName, drafttype, docname) {
    try {
      const token = localStorage.getItem("CurrentToken");
      const SiteURL = localStorage.getItem("SiteURL");
      const response = await axios.get(
        `${SiteURL}/_api/web/getfolderbyserverrelativeurl('CLM365RequestDraft')/files('${FileName}')?$expand=ListItemAllFields`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json;odata=verbose",
          },
        }
      );

      // e= response.data; // This will contain the file data with the ListItemAllFields
      const e = response?.data?.d;
      // console.log(e);
      const doclibname = e?.Name;
      let filenamenew = (e?.Name).split(".");
      let f1 = filenamenew.slice(0, -1);
      // setfileIdupdate(f1.join("."));
      setRetrieveFiles([]); 
      setRetrieveFiles2([]);
      let standardFile = [];
      let selectedStandFile;
      let selectedthirdFile;
      const tenantURL=localStorage.getItem("TenantURL");
      const fileURL = `${tenantURL}${e?.ServerRelativeUrl}`;
      const objectUrl = URL.createObjectURL(new Blob([e]));
      if (drafttype != "Attach your own file" && drafttype != "Blank") {

        
        // setstandardfile(
        standardFile = [
          <div>
            <div
              className={"Attatchemntdiv"}
              title={docname}
              style={{ marginTop: "5px", width: "auto", maxWidth: "none" }}
            >
              <span className={"Attatcmenticons"}>
                <Icon
                  styles={{
                    root: {
                      marginTop: "3px",
                      marginRight: "5px",
                      marginLeft: "5px",
                    },
                  }}
                  iconName="TextDocument"
                ></Icon>
              </span>
              <span className={"Attatchmentext1"}>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href={fileURL}
                  target="_blank"
                  download={docname}
                >
                  {docname}
                </a>
              </span>
              <Link
          style={{ marginLeft: "auto",paddingRight:'5px' }}
          onClick={()=>{
            SweetPromptAlert('warning','Are you sure you want to attach this document in email?').then((result)=>{
              if(result.isConfirmed){
                const outlookData=[{
                  attachmentName:docname,
                  fileUrl:objectUrl
                }]
                outlookAttachment(outlookData)
              }
            })

          }}
        >

          <AddRegular/>

        </Link>
            </div>
          </div>,
        ];
        // );
        // fetch(fileURL, {
        //   method: "GET",
        //   headers: {
        //     Accept: "application/json",
        //     Authorization: `Bearer ${token}`, // Ensure token is sent with fetch as well
        //   },
        // })
        //   .then((res) => res.blob()) // Gets the response and returns it as a blob
        //   .then((blob) => {
        //     const file = new File([blob], "template.docx", {
        //       type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        //     });
        //     // console.log("FileContent",file,blob)
        //     // Convert the blob to text
        //     const reader = new FileReader();
        //     reader.onload = function (event) {
        //       const fileContent = event.target.result;
        //       //   console.log("File Content:", fileContent);
        //     };
        //     reader.readAsText(blob);
        //     selectedStandFile = file;
        //   })
        //   .catch((error) => {
        //     console.error("Error fetching the file as a blob:", error);
        //   });
        // return;
      }
      if (drafttype == "Attach your own file") {
        setatt1 = [];
        setatt = [];
        setatt.push(e);
        setatt1.push([
          <div className={"Attatchemntdiv"} title={docname} style={{ marginTop: "1.9rem", width: "100%" }}>
            <span className={"Attatcmenticons"}>
              <Icon
                styles={{
                  root: {
                    marginTop: "3px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  },
                }}
                iconName="TextDocument"
              ></Icon>
            </span>
            <span className={"Attatchmentext1"}>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href={e?.ServerRelativeUrl}
                target="_blank"
                download={docname}
              >
                {docname}
              </a>
            </span>
            <Link 
            // onClick={deleteattach} 
            style={{ marginLeft: "auto",paddingRight:'5px' }}>
              {/* <IconButton
                styles={{
                  icon: {
                    color:
                      SettingService.GetTheme() == "light"
                        ? "var(--lightdarkColor) !important"
                        : "var(--lightdarkBGGray) !important",
                  },
                }}
                iconProps={Delete}
              /> */}
               <AddRegular       
                 style={{ marginLeft: "auto" }}
          onClick={()=>{
            SweetPromptAlert('warning','Are you sure you want to attach this document in email?').then((result)=>{
              if(result.isConfirmed){
                const outlookData=[{
                  attachmentName:docname,
                  fileUrl:objectUrl
                }]
                outlookAttachment(outlookData)
              }
            })
          }}/>
            </Link>
          </div>,
        ]);

        // fetch(fileURL, {
        //   method: "GET",
        //   headers: {
        //     Accept: "application/json",
        //     Authorization: `Bearer ${token}`, // Ensure token is sent with fetch as well
        //   },
        // })
        //   .then((res) => res.blob()) // Gets the response and returns it as a blob
        //   .then((blob) => {
        //     const file = new File([blob], "template.docx", {
        //       type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        //     });
        //     // Updateformfieldvalues(AllfieldValues,file,fileName, finalTemplatelib);
        //     //console.log(file);
        //     selectedthirdFile = file;
        //     // setselectedthirdfile(file);
        //   });
      }

      setData((c) => ({
        ...c,
        doclibname: doclibname,
        fileIdupdate: f1.join("."),
        standardfile: standardFile,
        selectedStandfile: selectedStandFile,
  
        selectedthirdfile: selectedthirdFile,
      }));

      setAttachfile(setatt1);
      setattachFile2(setatt);
      if(standardFile?.length){
        setRetrieveFiles((c) => ([...c,standardFile]));
      }else{
        setRetrieveFiles((c) => ([...c,...setatt1])); 
        setRetrieveFiles2((c) => ([...c,...setatt]));
      }
      
    } catch (error) {
      console.error("Error fetching the file:", error);
      // throw error; // Optionally, handle or rethrow the error
    }
  }

  async function getFilesByTask(RequestGuid) {
    try {
      const token = localStorage.getItem("CurrentToken");
      // Get the SharePoint site root URL and the folder URL
      const rootFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365TaskAttachment')/rootfolder`;
      const response = await axios.get(rootFolderUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      // Get the folder URL by appending the RequestGuid to the root folder
      const rootFolder = response.data;
      const folderUrl = `${rootFolder.ServerRelativeUrl}/${RequestGuid}`;
      taskAttachmentRoot=folderUrl;
      // Request the files in the folder

      const filesUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files?$expand=ListItemAllFields`;
      const filesResponse = await axios.get(filesUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const files = filesResponse.data.value || [];
      remarksetatt=[];
      remarksetatt1=[]
      // Process the files
      let varlnth1 = 0;
      files.forEach((file) => {
        let internalname = "";
        const fileName = file.ListItemAllFields.File_Name;
        const objectUrl = URL.createObjectURL(new Blob([file]));
        setatt1 = [];
        for (const key in attachmentFileDataTemp) {
          if (attachmentFileDataTemp.hasOwnProperty(key)) {
            const guid = attachmentFileDataTemp[key];

            if (guid === file.Name) {
              setatt1.push([
                <div className={"Attatchemntdiv"} title={fileName}>
                  <span className={"Attatcmenticons"}>
                    <Icon
                      styles={{
                        root: {
                          marginTop: "3px",
                          marginRight: "5px",
                          marginLeft: "5px",
                        },
                      }}
                      iconName="TextDocument"
                    ></Icon>
                  </span>
                  <span className={"Attatchmentext1"}>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      href={file.ServerRelativeUrl}
                      target="_blank"
                      download={fileName}
                    >
                      {fileName}
                    </a>
                  </span>
                  {/* <Link onClick={() => deleteCustomattach(key, guid)} style={{ marginLeft: "auto" }}>
                    <IconButton
                      styles={{
                        icon: {
                          color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important",
                        },
                      }}
                      iconProps={Delete}
                    />
                  </Link> */}
                        <Link
          // onClick={() => {
          //   deleteCustomattach(id);
          // }}
          style={{ marginLeft: "auto" ,paddingRight:'5px'}}
        >

          <AddRegular         style={{ marginLeft: "auto" }}
          onClick={()=>{
            SweetPromptAlert('warning','Are you sure you want to attach this document in email?').then((result)=>{
              if(result.isConfirmed){
                const outlookData=[{
                  attachmentName:fileName,
                  fileUrl:objectUrl
                }]
                outlookAttachment(outlookData)
              }
            })
 
          }}/>

        </Link>
                </div>,
              ]);
              attachmentFileData[key] = [setatt1];
              setAttachmentFileData({ ...attachmentFileData });
            }
          }
        }

        for (const key in documentTypesKeyPairs) {
          if (documentTypesKeyPairs.hasOwnProperty(key)) {
            const guid = documentTypesKeyPairs[key];

            if (guid === file.Name) {
              setatt1.push([
                <div className={"Attatchemntdiv"} title={fileName}>
                  <span className={"Attatcmenticons"}>
                    <Icon
                      styles={{
                        root: {
                          marginTop: "3px",
                          marginRight: "5px",
                          marginLeft: "5px",
                        },
                      }}
                      iconName="TextDocument"
                    ></Icon>
                  </span>
                  <span className={"Attatchmentext1"}>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      href={file.ServerRelativeUrl}
                      target="_blank"
                      download={fileName}
                    >
                      {fileName}
                    </a>
                  </span>
                  {/* <Link onClick={() => deleteDocumentTypes(key, guid)} style={{ marginLeft: "auto" }}>
                    <IconButton
                      styles={{
                        icon: {
                          color:
                            SettingService.GetTheme() == "light"
                              ? "var(--lightdarkColor) !important"
                              : "var(--lightdarkBGGray) !important",
                        },
                      }}
                      iconProps={Delete}
                    />
                  </Link> */}
                        <Link
          // onClick={() => {
          //   deleteReterieveattach(id);
          // }}
          
          style={{ marginLeft: "auto",paddingRight:'5px' }}
        >

          {/* <IconButton
            styles={{
              icon: {
                color:
                  SettingService.GetTheme() == "light"
                    ? "var(--lightdarkColor) !important"
                    : "var(--lightdarkBGGray) !important",
              },
            }}
            iconProps={Delete}
          /> */}
          <AddRegular       style={{ marginLeft: "auto" }}
          onClick={()=>{
            SweetPromptAlert('warning','Are you sure you want to attach this document in email?').then((result)=>{
              if(result.isConfirmed){
                const outlookData=[{
                  attachmentName:fileName,
                  fileUrl:objectUrl
                }]
                outlookAttachment(outlookData)
              }
            })

          }}/>

        </Link>
                </div>,
              ]);
              documentTypesData[key] = [setatt1];
              setDocumentTypesData({ ...documentTypesData });
            }
          }
        }

        // if (file.ListItemAllFields?.AttachmentIntName === "Additional") {
          let id = varlnth1++;
          let delGuid = file.ListItemAllFields.File_Guid + "." + file.ListItemAllFields.File_Name?.split(".")[1];
          remarksetatt.push({
            name: fileName,
            content: file.ServerRelativeUrl,
            guid: delGuid,
          });
          remarksetatt1.push([
            <div className={"Attatchemntdiv"} title={fileName}>
              <span className={"Attatcmenticons"}>
                <Icon
                  styles={{
                    root: {
                      marginTop: "3px",
                      marginRight: "5px",
                      marginLeft: "5px",
                    },
                  }}
                  iconName="TextDocument"
                ></Icon>
              </span>
              <span className={"Attatchmentext1"}>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href={file.ServerRelativeUrl}
                  target="_blank"
                  download={fileName}
                >
                  {fileName}
                </a>
              </span>
              {/* <Link onClick={() => deleteattachremark(id, delGuid)} style={{ marginLeft: "auto" }}>
                <IconButton
                  styles={{
                    icon: {
                      color:
                        SettingService.GetTheme() == "light"
                          ? "var(--lightdarkColor) !important"
                          : "var(--lightdarkBGGray) !important",
                    },
                  }}
                  iconProps={Delete}
                />
              </Link> */}
                    <Link
          // onClick={() => {
          //   deleteReterieveattach(id);
          // }}
          style={{ marginLeft: "auto",paddingRight:'5px' }}
        >
          <AddRegular       style={{ marginLeft: "auto" }}
          onClick={()=>{
            SweetPromptAlert('warning','Are you sure you want to attach this document in email?').then((result)=>{
              if(result.isConfirmed){
                const outlookData=[{
                  attachmentName:fileName,
                  fileUrl:objectUrl
                }]
                outlookAttachment(outlookData)
              }
            })
 
          }}/>

        </Link>
            </div>,
          ]);
        // }
      });
      setattachremarkFile1([...remarksetatt1]);
      setRetrieveFiles((c) => ([...c, remarksetatt1]));
      setRetrieveFiles2((c) => ([...c, remarksetatt]));
      setattachremarkFile2([...remarksetatt]);
    } catch (error) {
      console.log(error);
    }
  }

  function deleteCustomattach(internalname, guid) {
    setFileImported(false);
    setAttachmentFileData((prevAttachmentData) => {
      let updatedAttachmentData = { ...prevAttachmentData };
      delete updatedAttachmentData[internalname];
      return updatedAttachmentData;
    });
    setatt1 = setatt1.filter((attachment) => attachment.key !== internalname);
    setAttachmentFile((c) => c?.filter((obj) => !obj.IntName || obj.IntName !== internalname));
    if (guid != "") {
      deleteAttachmentFiles[internalname] = guid;
      setDeleteAttachmentFiles({ ...deleteAttachmentFiles });
    }
  }

  function deleteattach(id) {
    setatt1 = [];
    setatt.splice(id, 1);
    //console.log(setatt);
    for (var i = 0; i < setatt.length; i++) {
      let id = i;
      setatt1.push([
        <div>
          <span>{setatt[i].name}</span>
          <Link
            onClick={() => {
              deleteattach(id);
            }}
          >
            <IconButton
              styles={{
                icon: {
                  color:
                    SettingService.GetTheme() == "light"
                      ? "var(--lightdarkColor) !important"
                      : "var(--lightdarkBGGray) !important",
                },
              }}
              iconProps={Delete}
            />
          </Link>
        </div>,
      ]);
    }

    setData((c) => ({
      ...c,
      attachFile2: setatt,
      attachfile: setatt1,
      FileImported: false,
    }));
  }

  function deleteDocumentTypes(internalname, guid) {
    setFileImported(false);
    setDocumentTypesData((prevAttachmentData) => {
      let updatedAttachmentData = { ...prevAttachmentData };
      delete updatedAttachmentData[internalname];
      return updatedAttachmentData;
    });
    setatt1 = setatt1.filter((attachment) => attachment.key !== internalname);
    setDocumentTypeFiles((c) => c?.filter((obj) => !obj.IntName || obj.IntName !== internalname));
    if (guid != "") {
      deleteDocumentsTypes[internalname] = guid;
      setDeleteDocumentTypes({ ...deleteDocumentsTypes });
    }
  }

  function deleteattachremark(id, guid) {
    remarksetatt1 = [];
    remarksetatt.splice(id, 1);
    addattachmentNames = [];
    for (var i = 0; i < remarksetatt.length; i++) {
      let id = i;
      addattachmentNames.push(remarksetatt[i].name);
      remarksetatt1.push([
        <div
          className={"Attatchemntdiv"}
          title={remarksetatt[i].name}
          // style={{width:"10.8rem"}}
        >
          <span className={"Attatcmenticons"}>
            <Icon
              styles={{
                root: {
                  marginTop: "3px",
                  marginRight: "5px",
                  marginLeft: "5px",
                },
              }}
              iconName="TextDocument"
            ></Icon>
          </span>
          <span className={"Attatchmentext1"}>{remarksetatt[i].name}</span>
          {/* <Link
            onClick={() => {
              deleteattachremark(id, remarksetatt[id].guid);
            }}
          >
            
            <IconButton
              styles={{
                icon: {
                  color:
                    SettingService.GetTheme() == "light"
                      ? "var(--lightdarkColor) !important"
                      : "var(--lightdarkBGGray) !important",
                },
              }}
              iconProps={Delete}
            />
          </Link> */}
                <Link
          // onClick={() => {
          //   deleteReterieveattach(id);
          // }}
          style={{ marginLeft: "auto",paddingRight:'5px' }}
        >
          <AddRegular/>

        </Link>
        </div>,
      ]);
    }
    setattachremarkFile1([...remarksetatt1]);
    setattachremarkFile2([...remarksetatt]);
    setRetrieveFiles((c) => ([...c, remarksetatt1]));
    setRetrieveFiles2((c) => ([...c, remarksetatt]));
    if (guid != "") {
      deleteRemarkattach.push(guid);
      setDeleteRemarkAttach(deleteRemarkattach);
    }
  }

  function getDocumentAttachments(listGUID) {
   
    setDocumentTypeTemp([]);
    documentTypesKeyPairs = {};
    documentTypeID = "";
    const token = localStorage.getItem("CurrentToken");
    axios
      .get(
        `${ContextService.GetUrl()}` +
          `/_api/web/lists/getbytitle('CLM365DocumentAttachment')/Items?$select=*&$filter=RequestContract_GuidID eq '${listGUID}'`,
        {
          headers: {
            Accept: "application/json;odata=nometadata",
            "odata-version": "",
            Authorization: `Bearer ${token}`,
          },
        }
      )

      .then((items: any) => {
        if (items?.value[0]) {
          documentTypeID = items?.value[0]?.ID;
          const keyValuePairs = {};
          let tempData = items.value[0];
          for (const key in tempData) {
            documentTypesTemp.forEach((doc) => {
              if (doc.IntName === key) {
                keyValuePairs[doc.IntName] = tempData[key];
                documentTypesKeyPairs[doc.IntName] = tempData[key];
              }
            });
          }
          setDocumentTypeTemp(keyValuePairs);
        }
      })
      .catch((error) => {});
  }

 async function uploadFilesInBatch(filesDataArray, folderName) {
    try {
      const web = new Web(ContextService.GetUrl());
      const library = web.lists.getByTitle("CLM365TaskAttachment");
      await library.rootFolder.folders.add(folderName);
      const batch = web.createBatch();
  
      for (let i = 0; i < filesDataArray.length; i++) {
        if(filesDataArray[i]){
        // const { fileName, fileContent, finalTemplatelibrary } = filesDataArray[i];
        const fileName=filesDataArray[i]?.GUID;
        const fileContent=filesDataArray[i]?.FileContent;
        let fileGuid = uniqueGUID.toString();
        let finalTemplatelibrary = {
          TaskID: folderName,
          File_Name: filesDataArray[i]?.FileName,
          File_Guid:filesDataArray[i]?.GUID?.split('.')[0],
          AttachmentIntName:filesDataArray[i]?.IntName,
        };
        const rootFolder = await library.rootFolder.get();
        const folderUrl = `${rootFolder.ServerRelativeUrl}/${folderName}`;
        const folder = web.getFolderByServerRelativeUrl(folderUrl);

        //for deleting old files
        const files = await folder.files.get();
        const fileToDelete =files.filter(file => file?.Name.split('.')[0] === fileName.split('.')[0])?.filter(f=>f?.Name!=fileName)
        if(fileToDelete!=null&&fileToDelete.length>0){
          let fileNameTemp=fileToDelete[0]?.Name
          const fileUrl = `${folderUrl}/${fileNameTemp}`;
          const file = web.getFileByServerRelativeUrl(fileUrl);
          await file.delete();
        }

        folder.files.inBatch(batch).add(fileName, fileContent, true)
          .then(async (file) => {
            const item = await file.file.getItem();
            item.update(finalTemplatelibrary);
          })
          .catch((error) => {
            console.error(`Error uploading file ${fileName}:`, error);
          });
        }
      }
  
      await batch.execute();
      console.log("Files uploaded successfully.");
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  }

 
// const submitRetrieveFiles= async()=>{
//   console.log(addedFiles)

// const folderUrl =taskAttachmentRoot;  // Folder URL
// let outlookData=[]
// for (let i = 0; i < addedFiles.length; i++) {
//   const file = addedFiles[i];
//   const fileName = file.name;
//   const fileData = file;  // File object to send

//   // Define the URL to upload the file to SharePoint
//   const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileName}')`;

//   try {
//     // Send the POST request to upload the file
//     const uploadFileResponse = await axios.post(uploadFileUrl, fileData, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json",
//         "Content-Type": "application/octet-stream"  // Set content type to binary stream
//       }
//     });

//     console.log(`File ${fileName} uploaded successfully:`, uploadFileResponse.data);
  
//     if(uploadFileResponse.data.ServerRelativeUrl){
//       const serverURL= "https://megazap.sharepoint.com"+uploadFileResponse.data.ServerRelativeUrl;
//       const objectUrl = URL.createObjectURL(new Blob([fileData]));
//       console.log(objectUrl)
//       outlookData.push({
//         attachmentName:fileName,
//         fileUrl:objectUrl
//       })
//     }

//   } catch (error) {
//     console.error(`Error uploading file ${fileName}:`, error);
//   }
// }
// if(outlookData?.length){
//   // addAttachment(outlookData)
//     outlookAttachment(outlookData)
//     // addMultipleAttachments(outlookData)
// }
// }


async function getBase64FromUrl(url: string): Promise<string> {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const result = reader.result;

      if (typeof result === "string") {
        const base64 = result.split(",")[1];
        resolve(base64);
      } else {
        reject("Failed to read file as base64");
      }
    };

    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}


async function outlookAttachment(outlookData) {
  const item = Office.context.mailbox.item;

  for (let index = 0; index < outlookData.length; index++) {
    const element = outlookData[index];

    try {
      const base64File = await getBase64FromUrl(element.fileUrl);

      item.addFileAttachmentFromBase64Async(
        base64File,
        element.attachmentName,
        { isInline: false },
        function (result) {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            console.log("Attachment added:", element.attachmentName);
          } else {
            console.error("Attachment failed:", result.error.message);
          }
        }
      );
    } catch (err) {
      console.error("Error processing attachment:", err);
    }
  }
}

  return (
    <div id="SweetalertGetFilesRequest">
      {spinnerLoading &&  <div style={{position:'absolute',top:'50%',left:'30%'}}>
             <Spinner label="Please wait..." ariaLive="assertive" labelPosition="right" />
           </div>}
      {/* <div className="BackButtonContainer">
        <ArrowCircleLeftRegular onClick={()=>props.setisGetFilesCLM(false)}/>
        </div> */}
         {/*  */}
         {!spinnerLoading &&<><div style={{fontWeight:'600',paddingBottom:'10px'}}>
         <Label>Retrieve files from Contract Management</Label>
     
      </div>
      <Select
        placeholder={"Select Request"}
        options={allRequestOpt}
        value={
          selectedRequest != undefined &&
          selectedRequest != null &&
          allRequestOpt.filter(({ key }) => key === selectedRequest)
        }
        isSearchable={true}
        onChange={(select) => onChangeRequest(select)}
        styles={customStyles}
      /></>}
    {/* <Label>Attachments</Label> */}
      {/* <DragAndDrop
        FileID="DragandDropFileId"
        // draggableContainerStyle={{
          // minHeight: "50px",
          // height: heightValue,
          // marginTop: "-1rem",
        // }}
        // draggableContainerStyle1={{ left: "44%" }}
        showLabel={true}
        multiple={true}
        onChangeAdd={onChangeRetrieveFile}
        accept=".docx,.pdf,.doc"
        selectedFile={RetrieveFiles}
        key={JSON.stringify(RetrieveFiles)}
      /> */}
      {RetrieveFiles?.length?
      <div className="ModalAttachmentsDivrequestform">{RetrieveFiles}</div>
      :(RetrieveFiles?.length==selectedRequest)?<div style={{padding:'10px',textAlign:'center'}} >{"Attachment(s) not found"}</div>:null}


    </div>
  );
}

export default GetFilesCLM;
